package com.xtream.composeapp.viewmodel


 import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import androidx.paging.Pager
import androidx.paging.PagingConfig
import androidx.paging.PagingData
import androidx.paging.cachedIn
import androidx.paging.filter
import androidx.paging.map
import com.xtream.composeapp.SharedBuildKonfig
import com.xtream.data_kmp.AllConst
import com.xtream.data_kmp.AllConst.PAGING_MIN_PAGE_SIZE
import com.xtream.data_kmp.AllConst.PAGING_PAGE_SIZE
import com.xtream.data_kmp.FavoriteVodStreamEntity
import com.xtream.data_kmp.PreferencesRepo
import com.xtream.data_kmp.WatchedVodStreams
import com.xtream.data_kmp.db.repo.VodStreamsRepository
import com.xtream.data_kmp.db.repo.WatchedVodRepository
import com.xtream.data_kmp.dto.BaseStream
import com.xtream.data_kmp.dto.CategoryWithStream
import com.xtream.data_kmp.dto.TrendingMovie
import com.xtream.data_kmp.dto.VodCategory
import com.xtream.data_kmp.dto.VodStream
import com.xtream.data_kmp.remote.ApiService
import com.xtream.data_kmp.remote.createApiService
import io.ktor.client.call.body
import io.ktor.http.isSuccess
import kotlinx.coroutines.CoroutineExceptionHandler
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch
import kotlinx.coroutines.withContext
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.json.JsonObject
import kotlin.time.Clock

class VodStreamsViewModel (
    private val tvStreamsRepo: VodStreamsRepository,
    private val watchedStreamsRepo: WatchedVodRepository,
    private  val appSettingsRepo: PreferencesRepo,


    ) : ViewModel() ,SearchViewModelInterface by SearchViewModelImpl()  {


    private val _streamState = MutableStateFlow<VodStream?>(null)
    val streamState: StateFlow<VodStream?> = _streamState

    private val _recommendedItems = MutableStateFlow<List<VodStream>>(emptyList())
    val recommendedItems: StateFlow<List<VodStream>> = _recommendedItems

    @Deprecated( "Deprecated", ReplaceWith("loadRecommendations(id)"))
     fun loadRecommendations(id: Int?) {

         viewModelScope.launch {
             val stream = getVodByStreamId(id)
             _streamState.value = stream

             stream?.let {
                 val recommended = getRecommendedVodList(
                     stream.categoryId,
                     limit = 15,
                     excludeIds = listOf(stream.streamId)
                 )
                 recommended.collectLatest {
                     _recommendedItems.value = it
                 }

             }
         }
    }


    suspend fun  getVodByStreamId(id: Int?) = tvStreamsRepo.getVodByStreamId(id)

    /**
     * gets Movies Flow for given category Id and search Keyword
     * @return Flow<PagingData<SeriesStream>>
     */
    val  vodStreamsFilteredPagingFlow = combine(searchFlow,searchByCategoryFlow) { keyWord, category ->
        category to keyWord
    }
        .distinctUntilChanged() // ✅ Prevents unnecessary reloads

        .flatMapLatest { (category, keyWord) ->
        getPagedVodsFlow( category,keyWord)
    }
        .cachedIn(viewModelScope) // ✅ important!

    val vodCategoriesWithVisibleStatus = tvStreamsRepo
        .getCategoriesWithVisibleStatus()
        .stateIn(
            scope = viewModelScope,
            started = SharingStarted.WhileSubscribed(5000),
            initialValue = emptyList()
        )

    @ExperimentalStdlibApi
    val  categoriesPagerWithTvStreams = Pager(
        config = PagingConfig(
            pageSize = PAGING_MIN_PAGE_SIZE,
            enablePlaceholders = true,
        ),
        pagingSourceFactory = {

            tvStreamsRepo.getPagedCategoriesWithStreams()
        }
    ).flow.map {
        it.map { sizedCategory->
//Log.d("VodStreamsView", "categoriesPagerWithTvStreams: ${sizedCategory.category.categoryId}")
            CategoryWithStream<Any, VodCategory>( category = sizedCategory.category,
                size = sizedCategory.size,
                streams =  tvStreamsRepo.all(sizedCategory.category.categoryId))
        }
            .filter {itm-> itm.streams.isNotEmpty() }
    }.cachedIn(viewModelScope)

    /**
     * gets Top Ten Movies By Rating
     * @return [List] of [com.xtream.data.dto.VodStream]
     */
   suspend fun getTopTenVods() = tvStreamsRepo.getTopTens()

    val getTopTenFlow = tvStreamsRepo.topAsFlow().stateIn(
        scope = viewModelScope,
        started = SharingStarted.WhileSubscribed(5000),
        initialValue = null
    )


    fun getVodFlow(categoryId: Int? = null,
                   searchQuery: String? = null,
                   shuffle:Boolean=false,
                   limit: Int=20,
                   offset: Int?=null)= tvStreamsRepo.getStreamsFlow(categoryId=categoryId,limit = limit)


    /**
     * gets Movies Categories as [Flow]
     * @return  Flow<List<[com.xtream.data.dto.VodCategory]>?>
     */
    fun getVodCategoriesFlow() = tvStreamsRepo.getCategoriesAsFlow()


    /**
     * watched single Movie stream Flow
     */
    fun getWatchedSingleVodFlow(streamId: Int?) = watchedStreamsRepo.getWatchedStreamFlow(streamId)

    /**
     * watched single Movie stream Flow
     */
    suspend fun getWatched(streamId: Int?) = watchedStreamsRepo.getWatchedStream(streamId)

    suspend fun removeWatched(streamId: Int?) = watchedStreamsRepo.deleteById(streamId)


    @ExperimentalStdlibApi
    val  getCategoriesWithStreamsPager = Pager(
        config = PagingConfig(
            pageSize = PAGING_MIN_PAGE_SIZE,
            enablePlaceholders = false,
        ),

        pagingSourceFactory = {

            tvStreamsRepo.getCategoriesAsPagingFlow()
        }
    ).flow.map { categories ->
        // val startTime =   System.nanoTime()


        val res= categories.map {
            Pair(it,tvStreamsRepo.getStreamsFlow(it.categoryId, limit = 15))
        }
        // Log.e("Measure", "TASK took : " +  ((System.nanoTime()-startTime)/1000000)+ "mS")

        res
    }.cachedIn(viewModelScope)

    fun insertWatched( stream: WatchedVodStreams) {
        viewModelScope.launch(Dispatchers.Default) {
          //  Log.d( "VideoPlayer", "VideoPlayer url: ${ stream.progress}, ${stream.totalProgress}")

            if (stream.progress !=null && stream.totalProgress!=null) {
                if (stream.progress!! >= stream.totalProgress!!)
                    watchedStreamsRepo.deleteById(stream.streamId)
                else
                    watchedStreamsRepo.insert(stream)
            }
        } }


    /**
     * gets Movies Categories as Flow<PagingData<VodCategory>>
     * @return Flow<PagingData<VodCategory>>
     */
    val getVodCategoriesPaging: Flow<PagingData<VodCategory>> = Pager(
        config = PagingConfig(
            pageSize = PAGING_MIN_PAGE_SIZE,
            enablePlaceholders = false,
        ),
        pagingSourceFactory = {
            tvStreamsRepo.getCategoriesAsPagingFlow()
        }
    ).flow.cachedIn(viewModelScope)

    val testPaging = getVodCategoriesPaging.map {
        it.map { category->

            Pair( category , tvStreamsRepo.getStreamsFlow(category.categoryId, limit= 7))
        }
    }.cachedIn( viewModelScope)

    /**
     * gets Movies Rows count for given category Id
     * @property categoryId
     * oryId
     * @return  Flow<List<[com.xtream.data.dto.VodCategory]>?>
     */
    suspend fun getVodsSize(categoryId: Int? = null) = withContext(Dispatchers.Default) {
        return@withContext if (categoryId == AllConst.FAV_CATEGORIES_ID.toInt())
            tvStreamsRepo.favStreamsSize()
        else
            tvStreamsRepo.streamsSize(categoryId)
    }

    /**
     * gets Paginated Movies for given category Id
     * @property  categoryId id of the category
     * @property  searchQuery  id of the category
     * @return  Flow<PagingData<[com.xtream.data.dto.VodCategory]>>
     */
    fun getPagedVodsFlow(
        categoryId: Int? = null,
        searchQuery: String? = null,
        shuffle:Boolean=false,
        limit: Int?=null,
        offset: Int?=null


    ): Flow<PagingData<VodStream>> = Pager(
        config = PagingConfig(
            pageSize = PAGING_PAGE_SIZE,
            enablePlaceholders = false,
        ),
        pagingSourceFactory = {
            when (categoryId) {
                AllConst.FAV_CATEGORIES_ID.toInt() -> tvStreamsRepo.getFavoritesPagingSource()
                AllConst.WATCHED_CATEGORIES_ID.toInt() -> tvStreamsRepo.getPagedWatchedStreams()
                else -> tvStreamsRepo.getStreamsAsPagingSource(categoryId, searchQuery )
            }
        }
    ).flow.cachedIn(viewModelScope)


    fun getRecommendedCategoryWithVodList( categoryId: Int? = null,
        limit: Int,)=tvStreamsRepo.getRecommendationsList( categoryId, limit = limit).map {
        CategoryWithStream<Any, VodCategory>( category = VodCategory( categoryId ?: -1, "Related movies"),
            size = -1,
            streams =  it)
    }
    fun getRecommendedVodList( categoryId: Int? = null,
                                           limit: Int,         excludeIds: List<Int?>? = null
    )=
        tvStreamsRepo.getRecommendationsList( categoryId, limit = limit, excludeIds)



    fun getRecommendedPagedVodFlow(
        categoryId: Int? = null,
        limit: Int,


    ): Flow<PagingData<VodStream>> = Pager(
        config = PagingConfig(
            pageSize = PAGING_PAGE_SIZE,
            enablePlaceholders = false,
        ),
        pagingSourceFactory = {

                tvStreamsRepo.getRecommendations(categoryId,limit )
        }
    ).flow.cachedIn(viewModelScope)

    /**
     * adds stream to Favorites Table
     * @property  stream stream item to be added
     **/
    suspend fun addToFavorites(stream: BaseStream?) {
        withContext(Dispatchers.Default) {
            if (stream == null) return@withContext
            val fav = FavoriteVodStreamEntity().apply {
              this.streamId=  stream.streamId
                this.sortOrder=   Clock.System.now().toEpochMilliseconds()
            }
            tvStreamsRepo.insertFavorite(fav)
        }
    }
    /**
     * removes stream to Favorites Table
     * @property  stream stream item to be removed
     **/
    suspend fun deleteFromFavorites(stream: BaseStream?, onRemoved: () -> Unit) {
        withContext(Dispatchers.Default) {
            if (stream == null) return@withContext
            val fav = FavoriteVodStreamEntity().apply {this.streamId= stream.streamId }
            tvStreamsRepo.deleteFavorite(fav)
            onRemoved.invoke()
        }
    }


    /**
     * checks weather the given stream is available in Favorites Table?
     * @property  stream stream item to be checked
     * @return Flow< Boolean> returns true if the stream is in favorites table otherwise false
     **/
    fun isFavoriteFlow(stream: BaseStream?) =
        tvStreamsRepo.isFavoriteAsFlow(stream?.streamId)
    /**
     * checks weather the given stream is available in Favorites Table?
     * @property  stream stream item to be checked
     * @return Boolean returns true if the stream is in favorites table otherwise false
      **/
    suspend fun isFavorite(stream: BaseStream?) =
        withContext(Dispatchers.Default) {
            if (stream == null) return@withContext false
            tvStreamsRepo.isFavorite(stream.streamId) }


    /**
     * updates stream favorite status if it is not favorite it will add it and if it is already in favorites it will remove it
     */
    fun updateFavoriteStatus(stream: BaseStream?, onDone: (Boolean) -> Unit={}){
        viewModelScope.launch {
            if (stream == null) return@launch
            if (tvStreamsRepo.isFavorite(stream.streamId))
                deleteFromFavorites(stream) {
                    onDone.invoke(false)
                }
            else {
                addToFavorites(stream)
                onDone.invoke(true)

            }
        }

    }

    private val coroutineExceptionHandler = CoroutineExceptionHandler { _, throwable ->
        throwable.printStackTrace()
    }


    /**
     * Loads Movies and Movies Categories from Server
     * @property  username user name of the user
     * @property  password password of the user
     * @property  serverUrl server url
     * @return List< Job>
     **/
    fun loadVodStreams(username: String, password: String, serverUrl: String?): List<Job> {


      //error("loadVodStreams not implemented")
        val apiService =
            createApiService("$serverUrl${SharedBuildKonfig.SERVER_API}", username, password)
        val streamsJob = viewModelScope.launch(Dispatchers.Default + coroutineExceptionHandler) {
            val millis = Clock.System.now().toEpochMilliseconds()




            // val VodStreams = apiService.getVodStreams().body<String>()
            val vodStreams = apiService.getVodStreams()



            vodStreams?.also { list ->

                tvStreamsRepo.refreshData(list)





                }





        }
        val categoriesJob = viewModelScope.launch(Dispatchers.Default + coroutineExceptionHandler) {

            val millis = Clock.System.now().toEpochMilliseconds()

             val watched =
                VodCategory(
                    AllConst.WATCHED_CATEGORIES_ID.toInt(),
                    "Continue Watching"
                )
            val favCategory =
                VodCategory(AllConst.FAV_CATEGORIES_ID.toInt(), "Favorites")

            val vodCategories = apiService.getVodCategories()


            vodCategories?.also { list ->

              /*  if (BuildConfig.DEBUG) {
                    Log.d(
                        "#dataLoading",
                        "response vodCategories: " + ((Clock.System.now().toEpochMilliseconds() - millis) / 1000).toString() + " Sec"
                                + " , size: ${list.map { it.createdAt }}"
                    )
                }*/

                tvStreamsRepo.refreshCategories((listOf(favCategory, watched) + list))

            }


        }


        val trendingJob = viewModelScope.launch(Dispatchers.Default + coroutineExceptionHandler) {
            try {

                val tmdbKey: String = appSettingsRepo.getPref(PreferencesRepo.SERVER_TMDB_KEY) ?: ""
                val trending = apiService.tmdbTrendingMovies(tmdbKey)
                if (trending.status.isSuccess()) {
                    val json = trending.body<JsonObject>()
                    val results = json["results"]
                    val vodList: List<TrendingMovie>? = results?.let {
                        ApiService.jsonObj.decodeFromJsonElement(
                            deserializer = ListSerializer(
                                TrendingMovie.serializer()
                            ), it
                        )
                    }
                    tvStreamsRepo.refreshTrending(vodList)
                }
            } catch (e: Exception) {
            }

        }




        return listOf(categoriesJob, streamsJob, trendingJob)
        //  onResponse.invoke()

    }

    fun clearWatched() {
        viewModelScope.launch(Dispatchers.Default){
            watchedStreamsRepo.deleteAll()
        }
    }

    fun toggleCategoryVisibility(category: VodCategory){
        viewModelScope.launch {
            tvStreamsRepo.toggleLiveCategory(category)
        }
    }

}
